import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { Box, Stack, Typography, Button, Divider, Slide } from "@mui/material";
import PlayArrowRoundedIcon from "@mui/icons-material/PlayArrowRounded";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import SortIcon from "@mui/icons-material/Sort";
import InfoIcon from "@mui/icons-material/Info";
import PageHeader from "../../components/PageHeader";
import { Images } from "./../../assets/common";
import CloseIcon from "@mui/icons-material/Close";
import BidPopup from "../../components/BidPopup";
import ApiService from "./../../services/api-service";
import Loader from "./../../components/Loader";
import notifier from "../../components/Notifier";
import { useDispatch } from "react-redux";
import { getBalance } from "../../asyncAction/asyncBalance";
import {
  formatedDate,
  fullName,
  getErrorString,
  isOwnerId,
} from "./../../constants/function";
import ConfirmMusicNft from "../../components/ConfirmMusicNft";
export default function BuyBidInfo({ id, handleBack, isPlaylistNft }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [musicDetails, setMusicDetails] = useState({});
  const [owners, setOwners] = useState([]);
  const history = useHistory();
  const [show, setShow] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [openBuy, setOpenBuy] = React.useState(false);
  const [buyIndex, setBuyIndex] = React.useState(null);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (amount) => {
    setOpen(false);
    if (amount) {
      const temp = musicDetails;
      temp["highestBid"] = amount["amount"];
      setMusicDetails({ ...temp });
    }
  };
  const getMusicDetail = async (_id) => {
    try {
      setLoading(true);
      const response = isPlaylistNft
        ? await ApiService.PLAYLIST_NFT_BY_ID(_id)
        : await ApiService.NFT_BY_ID(_id);
      setMusicDetails(
        isPlaylistNft ? { ...response["result"] } : { ...response["result"][0] }
      );
      if (!isPlaylistNft) setOwners([...response["result"]]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const buy = async (e, currency, count) => {
    try {
      setLoading(true);
      const response = isPlaylistNft
        ? await ApiService.BUY_NFT({
            nftId: musicDetails["_id"],
            currency: currency,
            type: "playlist",
            count: 1,
          })
        : await ApiService.BUY_MUSIC_NFT({
            nftId: owners[buyIndex]["_id"],
            currency: currency,
            count: count,
          });
      notifier.success(response["result"]);
      dispatch(getBalance());
      setOpenBuy(false);
      setBuyIndex(null);
      getMusicDetail(id);
      // handleBack();
      history.push("/app/Nft");
      setLoading(false);
    } catch (error) {
      setOpenBuy(false);
      setBuyIndex(null);
      notifier.error(getErrorString(error));
      setLoading(false);
    }
  };
  useEffect(() => {
    if (id) getMusicDetail(id);
  }, []);
  return (
    <Slide direction="down" in={true} mountOnEnter unmountOnExit>
      <Box sx={{ overflow: "scroll", position: "relative" }}>
        <Box
          className="__main_pading"
          sx={{ background: "#262626", paddingTop: "1rem" }}
        >
          <Stack
            direction="row"
            sx={{ padding: "0 0 10px 0", borderBottom: "2px solid #1A1A1A" }}
          >
            <Typography
              sx={{ marginLeft: "auto !important" }}
              className="fs-20"
            >
              {/* Buy/ Bid */}
              Buy
            </Typography>
            <CloseIcon
              onClick={() => handleBack()}
              sx={{ marginLeft: "auto", cursor: "pointer" }}
              color="default"
            />
          </Stack>
          <Stack spacing={1} mt={1}>
            {isPlaylistNft && musicDetails["onSale"] ? (
              <Stack direction="row" justifyContent="space-between">
                <Box>
                  <Typography className="fs-13 fade-text">
                    Last Selling Price
                  </Typography>
                  <Typography className="fs-17">
                    {musicDetails["sellingPrice"]} SIKI Coins
                  </Typography>
                </Box>
                <Stack alignItems="center" spacing={1}>
                  <Button
                    sx={{ height: "36px !important" }}
                    onClick={() => setOpenBuy(true)}
                    variant="outlined"
                    color="default"
                  >
                    Buy
                  </Button>
                  <Typography className="fs-11 fade-text">On Sale</Typography>
                </Stack>
              </Stack>
            ) : null}
            {owners && owners.length > 0 ? (
              <Stack spacing={1} sx={{ padding: "10px" }}>
                <Typography className="fs-13 fade-text-60">
                  NFT Owned By ({owners.length})
                </Typography>
                {owners.map((owner, index) => (
                  <Stack
                    key={index}
                    direction="row"
                    spacing={1}
                    alignItems="center"
                    sx={{ marginBottom: "15px" }}
                  >
                    <Stack>
                      <img
                        className="avatar"
                        src={
                          owner["owner"]["profileImg"] &&
                          owner["owner"]["profileImg"]["filePath"]
                            ? owner["owner"]["profileImg"]["filePath"]
                            : Images.user_dummy
                        }
                        alt="owner"
                      />
                    </Stack>
                    <Stack>
                      <Typography className="fs-14 ">
                        {fullName(owner["owner"])}
                      </Typography>
                      <Typography className="fs-13 fade-text-60">
                        NFT on sale:{" "}
                        {owner["onSale"] ? owner["inSaleCount"] : 0}/
                        {owner["currentCount"]}
                      </Typography>
                    </Stack>
                    {isOwnerId(
                      owner["owner"] ? owner["owner"]["_id"] : null
                    ) ? null : (
                      <Stack
                        sx={{ marginLeft: "auto !important" }}
                        spacing={0.5}
                      >
                        {owner["onSale"] && owner["inSaleCount"] ? (
                          <Button
                            variant="outlined"
                            color="default"
                            onClick={() => {
                              setBuyIndex(index);
                              setOpenBuy(true);
                            }}
                            disabled={!owner["onSale"]}
                          >
                            Buy
                          </Button>
                        ) : null}
                        {owner["onSale"] && owner["inSaleCount"] ? (
                          <Stack direction="row" gap="5px" alignItems="center">
                            <Typography
                              className="fs-13 "
                              sx={{ color: "#62FFE1" }}
                            >
                              @ {owner["sellingPrice"].toFixed(4)}
                            </Typography>
                            <img
                              style={{ width: "20px" }}
                              src={Images.siki_coin}
                              alt="siki coin"
                            />
                            <Typography
                              className="fs-13 "
                              sx={{ color: "#62FFE1" }}
                            >
                              /nft
                            </Typography>
                          </Stack>
                        ) : null}
                      </Stack>
                    )}
                  </Stack>
                ))}
              </Stack>
            ) : null}
            {/* TODO: compressed for now*/}
            {isPlaylistNft ? (
              <Stack direction="row" justifyContent="space-between">
                <Box>
                  <Typography className="fs-13 fade-text">
                    Highest Bid
                  </Typography>
                  <Typography className="fs-17">
                    {musicDetails["highestBid"]}
                  </Typography>
                </Box>
                {/* {musicDetails["onAuction"] ? (
                  <Stack alignItems="center" spacing={1}>
                    <Button
                      variant="outlined"
                      color="default"
                      onClick={handleClickOpen}
                      disabled={musicDetails["status"] !== "started"}
                    >
                      Bid
                    </Button>
                    <Typography className="fs-11 fade-text">
                      On Auction
                    </Typography>
                  </Stack>
                ) : null} */}
              </Stack>
            ) : null}

            {/* <Stack direction="row" justifyContent="space-between">
              <Box>
                <Typography className="fs-13 fade-text">
                  NFT Owned By
                </Typography>
                <Typography className="fs-17">
                  {fullName(musicDetails["owner"] ? musicDetails["owner"] : "")}
                </Typography>
              </Box>
            </Stack> */}
            <Stack direction="row" justifyContent="space-between">
              <Box>
                <Typography className="fs-13 fade-text">
                  NFT Created Date
                </Typography>
                <Typography className="fs-17">
                  {formatedDate(musicDetails["createdDate"])}
                </Typography>
              </Box>
            </Stack>
            {isPlaylistNft && musicDetails["onAuction"] ? (
              <>
                <Stack direction="row" justifyContent="space-between">
                  <Box>
                    <Typography className="fs-13 fade-text">
                      NFT Auction Start Date
                    </Typography>
                    <Typography className="fs-17">
                      {musicDetails["startDateString"]}
                    </Typography>
                  </Box>
                </Stack>
                <Stack direction="row" justifyContent="space-between">
                  <Box>
                    <Typography className="fs-13 fade-text">
                      NFT Auction End Date
                    </Typography>
                    <Typography className="fs-17">
                      {musicDetails["endDateString"]}
                    </Typography>
                  </Box>
                </Stack>
              </>
            ) : null}
            {/* No Royality data comming from backend */}
            {/* {isPlaylistNft ? null : (
              <Stack>
                <Typography className="fs-13 fade-text">
                  Royality NFT (%)
                </Typography>
                <Stack spacing={2}>
                  <Stack direction="row" justifyContent="space-between">
                    <Typography className="fs-14 ">2%</Typography>
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      spacing={1}
                    >
                      <Typography className="fs-13 canceled">Owner</Typography>
                      <Typography className="fs-14 fade-text">
                        OwnerName
                      </Typography>
                    </Stack>
                  </Stack>
                  <Stack direction="row" justifyContent="space-between">
                    <Typography className="fs-14 ">2%</Typography>
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      spacing={1}
                    >
                      <Typography className="fs-14 ">UserName1</Typography>
                    </Stack>
                  </Stack>
                  <Stack direction="row" justifyContent="space-between">
                    <Typography className="fs-14 ">2%</Typography>
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      spacing={1}
                    >
                      <Typography className="fs-14 fade-text">
                        user.email@mail.com
                      </Typography>
                    </Stack>
                  </Stack>
                </Stack>
              </Stack>
            )} */}
          </Stack>
        </Box>
        {open ? (
          <BidPopup
            open={open}
            auctionId={musicDetails["auctionId"]}
            highestBid={musicDetails["highestBid"]}
            handleClose={handleClose}
            type={isPlaylistNft ? "playlist" : "music"}
          />
        ) : null}
        {openBuy ? (
          <BidPopup
            inSaleCount={
              typeof buyIndex === "number" && buyIndex >= 0
                ? owners[buyIndex]["inSaleCount"]
                : null
            }
            sellingPrice={
              typeof buyIndex === "number" && buyIndex >= 0
                ? owners[buyIndex]["sellingPrice"]
                : musicDetails["sellingPrice"]
            }
            isBuy={true}
            open={openBuy}
            handleClose={(e, currency, count) =>
              e && currency ? buy(e, currency, count) : setOpenBuy(false)
            }
          />
        ) : null}
        {loading ? <Loader /> : null}
        {show ? (
          <ConfirmMusicNft
            open={show}
            handleClose={(e, currency) =>
              !e ? buy(e, currency) : setShow(false)
            }
          />
        ) : null}
      </Box>
    </Slide>
  );
}
